import { Component } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MssFieldBaseFieldTypeComponent } from '../mss-field-base.component';
import { MSS_FORMLY_IMPORTS } from '../../formly-standalone-imports';

@Component({
  styleUrls: ['radio-list.component.scss'],
  templateUrl: 'radio-list.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ...MSS_FORMLY_IMPORTS,
  ],
})
export class RadioListComponent extends MssFieldBaseFieldTypeComponent {
  public defaultOptions = {
    props: {
      options: [] as unknown[],
      formCheck: 'custom', // 'custom' | 'stacked' | 'inline'
    },
  };

  public get optionsArray(): any[] {
    return (this.props.options as any[]) ?? [];
  }
}
